// extracted by mini-css-extract-plugin
export var isPrintedCell = "_x7-1";
export var printerIcon = "_x7-0";